import axios, { AxiosResponse } from "axios";
import { startLoading, stopLoading } from "../common/utils/button-loading";
import { hideNotice, showNotice } from "../common/utils/notice";
import { closePopup } from "../popup/popup";
import { getErrorMsg } from "../common/utils/request";

declare var pm: PmInterface;
let doingAjax = false;

export default function submitReporting(form: HTMLElement) {
	const { findHtmlEl, findButtonEl, findSelectEl } = pm.utils.dom;

	const objectType = form.dataset.reportedObjectType;
	const notice = findHtmlEl(form, ".submission-notice");
	if (notice) hideNotice(notice);

	const reasonSelectbox = findSelectEl(
		form,
		'[name="' + objectType + '_reporting_reason"]',
	);

	const reason = reasonSelectbox ? reasonSelectbox.value : "other";
	const button = findButtonEl(form, ".submit-button");

	if (doingAjax) return;
	doingAjax = true;

	startLoading(button);

	const formData = new FormData();

	const triggerOrigin = form.dataset.triggerOrigin
		? form.dataset.triggerOrigin
		: "";

	if (objectType === "photo") {
		if (triggerOrigin === "context-menu") {
			formData.append("as_curator", "1");
		} else if (triggerOrigin === "photo-popup") {
			formData.append("from_photo_popup", "1");
		}
	} else if (objectType === "comment") {
		if (triggerOrigin === "photo-popup") {
			formData.append("from_photo_popup", "1");
		}
	}

	formData.append("action", "pm_report_" + objectType);
	formData.append("nonce", form.dataset.pmNonce ? form.dataset.pmNonce : "");
	formData.append(
		objectType + "_id",
		form.dataset.reportedObjectId ? form.dataset.reportedObjectId : "",
	);
	formData.append("reason", reason);

	axios({
		method: "post",
		url: pm.ajaxurl,
		data: formData,
	})
		.then((response: AxiosResponse<any>) => {
			if (!response.data || !response.data.success) {
				const errorMsg = getErrorMsg(response);
				if (notice) showNotice(notice, errorMsg, "error");
				return;
			}

			if (notice) {
				showNotice(notice, response.data.data, "success");
			}

			setTimeout(() => {
				closePopup("reporting");
			}, 3000);
		})
		.catch((response: AxiosResponse<any>) => {
			const errorMsg = getErrorMsg(response);
			if (notice) showNotice(notice, errorMsg, "error");
		})
		.then(() => {
			doingAjax = false;
			stopLoading(button);
		});
}
